import { format } from 'date-fns';
export function getAccountBadgeZipFileName() {
    const dateAndTime = format(new Date(), 'MMddyyyy_HHmmss');
    return `${['account', 'badges', dateAndTime].filter((val) => val).join('_')}.zip`;
}
